import { STORAGE_KEYS, Storage } from '../utils/store';
import translator from '../utils/translation';

class HttpClient {
    #authGuard;
    
    constructor (authGuard) {
        const defaultWrapper = (url, params) => fetch(url, params);
        
        this.#authGuard = authGuard ?? defaultWrapper;
    }

    runRequest(method, resource, headers = {}, params = undefined, data = undefined, getRawResponse = false) {
    
        let baseUrl = `${process.env.GENDLOC_BACKEND_URL}`.startsWith('http')
            ? `${process.env.GENDLOC_BACKEND_URL}`
            : window.location.origin + `${process.env.GENDLOC_BACKEND_URL}`;

        if (resource.startsWith('http')) {
            baseUrl = '';
        }

        let queryParams = '';

        if (Object.keys(params ?? {})?.length) {
            queryParams = `?${new URLSearchParams(params).toString()}`;
        }

        const isFormData = data instanceof FormData;
        
        let body = undefined;
        
        if (data) {
            if (isFormData) {
                body = data
            } else {
                body = JSON.stringify(data);
                headers['Content-Type'] = 'application/json'
            }
        }

        Object.keys(headers).forEach(k => {
            if (!headers[k]) { delete headers[k] }
        });

        return this.#parseResponse(getRawResponse, this.#authGuard(
            `${baseUrl}${resource}${queryParams}`,
            { method, body, headers }
        ));
    }

    #parseResponse(getRawResponse, res) {
        return res.then(async response => {
            if (response.status == 204) { return getRawResponse ? response : {}; }

            if (response.ok) {
                return getRawResponse ? response : await response.json();
            }

            return Promise.reject({
                status: response.status,
                ...(await response.json())
            });
        });
    }

    handleRejection(error) {
        console.error(`API: ${error.status} - (${error.code ?? 'XX'}) ${translator.t(error.key)}\n ${error.details ?? ''}`);
        M.toast({html: `${translator.t(error.key)} (${error.code ?? 'Erreur inconnue'})`, classes: 'red'});
    }
};

export const initHttpClient = (authGuard) => new Proxy(new HttpClient(authGuard), {
    get(target, prop, receiver) {
        if (['handleRejection'].includes(prop)) { 
            return target[prop];
        }

        return function (resource, options = {}) {
            return target.runRequest(
                prop.toUpperCase(), 
                resource, 
                options.headers ?? {}, 
                options.params, 
                options.data, 
                options.getRawResponse ?? false
            );
        }
    }
})
